export const DEFAULT_MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

/** Returns true when the file size is invalid (empty or exceeds max). */
export const isInvalidFileSize = (size: number, max = DEFAULT_MAX_FILE_SIZE): boolean =>
  size <= 0 || size > max;
